"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SaleorProvider = void 0;
const react_1 = __importStar(require("react"));
const __1 = require("../");
const __2 = require("../../../");
const context_1 = require("../../context");
exports.SaleorProvider = ({ client, config, children, }) => {
    const [context, setContext] = react_1.useState(null);
    react_1.useMemo(() => {
        const manager = new __2.SaleorManager(client, config);
        manager.connect((saleorAPI) => setContext(Object.assign({}, saleorAPI)));
        return manager;
    }, [client]);
    return (react_1.default.createElement(context_1.SaleorContext.Provider, { value: context }, context ? react_1.default.createElement(__1.CredentialsProvider, null, children) : react_1.default.createElement(react_1.default.Fragment, null)));
};
//# sourceMappingURL=SaleorProvider.js.map